import axios from "axios";
const  getTabsIsUsedResult = function(res) {//获取各页面tab页签表格是否有数据，显示*
    const classId = this.$store.state.objectId.classId;
    let postData = {
        objectId:this.$store.state.objectId.id,
        changeId:this.$store.state.change_info.changeId,
        classId:classId,
        tabIds:res,
    };
    let tabsMapKey = classId.toString().substring(0,3);
    const tabsMap = new Map([
        ["101", "/pmdm/items/getTabsIsUsedResult"],
        ["104", "/pmdm/items/getTabsIsUsedResult"],
        ["501", "/pmdm/technology/getTabsIsUsedResult"],
        ["401", "/pqm/quality/getTabsIsUsedResult"],
        ["502", "/pmdm/technology/getTabsIsUsedResult"],
    ]);
    let url = tabsMap.get(tabsMapKey);
    console.log(url);
    return new Promise((resolve,reject) => {
        
         axios.post(url,postData).then(res =>{
            
            //console.log(res.data.object);
            let tabResult = [];
            const list = res.data.object;
            for(var item in list){
                if(list[item]){
                    tabResult.push(Number(item));
                };
            };
            resolve (tabResult);
        }).catch((e) =>{});
    })
};
export { getTabsIsUsedResult }